import Icon from '@amzn/awsui-components-core/icon';
import React from 'react';
import { NewsFeedItem } from 'src/services/NewsFeedService';
import { getAtozContentUrl } from '../utils/welcome-banner-utils';

interface NewsTickerCardProps {
  newsItem: NewsFeedItem;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  ariaLabel: string;
}

/**
 * @feature landing-page
 * @description D&S News ticker card — displays a single news item at a time with author and title.
 * Auto-rotation is managed by parent hook; this card just handles hover pause signaling.
 */
const NewsTickerCard: React.FC<NewsTickerCardProps> = ({ newsItem, onMouseEnter, onMouseLeave, ariaLabel }) => (
  <div className="landing-welcome-banner__card" data-testid="news-ticker-card" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
    <a
      className="landing-welcome-banner__card-link"
      href={getAtozContentUrl(newsItem.feedId)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={ariaLabel}
    >
      <Icon name="external" size="small" />
    </a>
    <svg className="landing-welcome-banner__news-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="3" y="4" width="18" height="16" rx="2" fill="#232F3E" opacity="0.08" />
      <rect x="3" y="4" width="18" height="16" rx="2" stroke="#FF9900" strokeWidth="1.5" />
      <path d="M7 9h10M7 12.5h6" stroke="#FF9900" strokeWidth="1.5" strokeLinecap="round" />
      <rect x="15" y="11" width="4" height="4" rx="0.5" fill="#FF9900" opacity="0.3" />
    </svg>
    <div className="landing-welcome-banner__card-content">
      <span className="landing-welcome-banner__card-label">{newsItem.authorName}</span>
      <span className="landing-welcome-banner__card-value landing-welcome-banner__news-title">{newsItem.title}</span>
    </div>
  </div>
);

export default NewsTickerCard;
